import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import AccountDialog from '@/modules/Account/scripts/accounts-list'
import ContactDialog from '@/modules/Contact/scripts/contact-dialog'
import ContactDetailDetail from '@/modules/Contact/views/detail.vue'
import { getContact } from '@/modules/Contact/gql/contact.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    ContactDetailDetail
  }
})
export default class ContactDetail extends mixins(ContactDialog, AccountDialog, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Client Information'
    },
    {
      text: 'Contacts',
      to: { name: 'ContactList' }
    }
  ]

  contactName = ''

  contact: Contact | null = null

  totalNum = 0
  contactsLoading = true
  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    name: 'NAME',
    site: 'SITE',
    phone: 'PHONE',
    updatedAt: 'UPDATED_AT'
  }

  tabActive = 0
  tabItems = [
    { title: 'Details', route: 'ContactDetailDetail' },
    { title: 'Accounts', route: 'ContactDetailAccount' },
    { title: 'Policies (Contact For)', route: 'ContactDetailPolicy' },
    { title: 'Quotes (Contact For)', route: 'ContactDetailQuotes' },
    { title: 'Documents', route: 'ContactDetailDocument' },
    {
      title: 'Additional',
      route: 'ContactDetailAdditional'
    }
  ]

  dateTimeToDisplay = dateTimeToDisplay
  formatPhoneNumber = formatPhoneNumber

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  get recordType () {
    if (this.$R.isEmpty(this.recordTypes) || !this.contact) {
      return null
    }
    const recordTypeId = this.contact.recordType.id
    return this.$R.find((recordType: RecordType) => {
      return recordType.id === recordTypeId
    })(this.recordTypes)
  }

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.onResize()
    this.getContact()
    await this.getRecordTypes('CONTACT')
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async getContact () {
    const contactId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getContact,
        variables: {
          contactId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.contact = result.data.getContact as Contact
      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: this.contact.name
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteContactConfirm () {
    await this.deleteContactPost()
    this.$router.replace({
      name: 'ContactList'
    })
  }
}
